// extracted by mini-css-extract-plugin
export default {"button":"tk-z","reviewSort":"uk-z"};